import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const TopupForm = ({ customerData, setCustomerData, depositUSDT }) => {
    const handleChange = (e) => {
        const { value, name } = e.target;

        setCustomerData((prev) => ({ ...prev, [name]: value }));
    }

    const handleCheckAmt = (e) => {
        const { value, name } = e.target;

        if (value < 5) {
            alert("Minimum Investment is 5 USDT");
            setCustomerData((prev) => ({...prev, [name]: ""}))
            return;
        }
    }

    return (
        <form class="login mt-2" id="signup"
            onSubmit={(e) => depositUSDT(e)}
        >
            <input type="text" class="form-control login-field mt-4" id="txtAmount"
                placeholder="Amount" name="amount"
                value={customerData?.amount} required
                onChange={(e) => handleChange(e)}
                onBlur={(e) => handleCheckAmt(e)}
            />

            <span class="form-field-notification" id='cusVerify'></span>

            <div class="my-3 w-100 d-flex">
                {/* <div class="me-2" style={{ fontSize: '13px' }}>
                                        <input class="form-check-input ms-1" type="checkbox" id="tandc" name="tandc" required />
                                        By continuing, you agree to our <Link to="/parivacy">Privacy Policy</Link> and <Link to="/termas" style={{ textDecoration: 'underline' }}>T&amp;C</Link>
                                    </div> */}
            </div>

            {/* div to show reCAPTCHA  */}
            <div class="g-recaptcha" data-sitekey=""></div>
            <button className="btn w-100 sign-in-btn g-recaptcha"
            // onClick={depositUSDT}
            >
                Send
            </button>
        </form>
    )
}

export default TopupForm;